import { HttpResponse } from '@angular/common/http';

import { ServerError } from './server.error';

export class ServerResponse<T = any, M = any> {
  errors: { [index: string]: any; } = {};
  system_errors = [];
  status?: number;
  value?: T;
  page?: number;
  current_page?: number;
  per_page?: number;
  has_errors = false;
  meta: M = {} as M;

  constructor(response: HttpResponse<T>, value_key: string) {
    const data = response.body;
    this.load_value(data, value_key);
    this.load_meta(data);
    this.load_errors(data);
  }

  has_value(): boolean {
    return typeof this.value !== 'undefined' && this.value != null;
  }

  private load_errors(data: any): void {
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!data) {
      // eslint-disable-next-line no-restricted-syntax
      for (const objectName in data['errors']) {
        if (data['errors']['base']) {
          this.has_errors = true;
          this.system_errors = data['errors']['base'];
        } else {
          // eslint-disable-next-line no-restricted-syntax, guard-for-in
          for (const fieldName in data['errors'][objectName]) {
            const value = data['errors'][objectName][fieldName];
            if (!this.errors[objectName]) {
              this.errors[objectName] = {};
            }
            this.has_errors = true;
            this.errors[objectName][fieldName] = new ServerError(fieldName, value);
          }
        }
      }
    }
  }

  private load_meta(data: any): void {
    if (!!data && !!data.meta) this.meta = data.meta;
  }

  private load_value(data: any, value_key: string): void {
    this.value = data && data[value_key] ? data[value_key] : null;
  }
}
